<script setup>
import {onMounted, ref} from 'vue';
import {APIService} from '@/core/util/services/api.service';
import OnboardingTable from '../components/OnboardingTable.vue';

const http = new APIService(window.appGlobal.baseUrl, 'api/v2/pim/employees');

const employees = ref([]);

onMounted(async () => {
  await http
    .request({
      includeEmployees: 'onlyCurrent',
      method: 'GET',
      url: '/api/training/get-all-employees',
    })
    .then(response => {
      employees.value = response.data.data.map(employee => {
        return {
          id: employee.empNumber,
          label: `${employee.firstName} ${employee.middleName} ${employee.lastName}`,
        };
      });
    });
});
</script>
<template>
  <div class="orangehrm-background-container">
    <OnboardingTable>
      <template #default="{filters, onReset, onSubmit}">
        <oxd-table-filter filter-title="Onboarding list">
          <oxd-form @reset="onReset" @submit="onSubmit">
            <oxd-form-row>
              <oxd-grid :cols="4" class="orangehrm-full-width-grid">
                <oxd-grid-item>
                  <oxd-input-field
                    v-model="filters.owners"
                    label="Owners"
                    value="Select"
                    type="multiselect"
                    :options="employees"
                  />
                </oxd-grid-item>
                <oxd-grid-item>
                  <oxd-input-field
                    v-model="filters.assignes"
                    label="Assigned to"
                    value="Select"
                    type="multiselect"
                    :options="employees"
                  />
                </oxd-grid-item>
                <oxd-grid-item>
                  <date-input v-model="filters.dueDate" label="Due Date" />
                </oxd-grid-item>
              </oxd-grid>
            </oxd-form-row>

            <oxd-divider />

            <oxd-form-actions>
              <required-text />
              <oxd-button
                display-type="ghost"
                :label="$t('general.reset')"
                type="reset"
              />
              <oxd-button
                class="orangehrm-left-space"
                display-type="secondary"
                :label="$t('general.search')"
                type="submit"
              />
            </oxd-form-actions>
          </oxd-form>
        </oxd-table-filter>
      </template>
    </OnboardingTable>
  </div>
</template>
